module.exports = __webpack_public_path__ + "static/media/banner-grid-03.9a5e201b.jpg";